import { useNavigate } from 'react-router-dom';
import './Orders.css';
import ProfileGoBackButton from '../ProfileGoBackButton/ProfileGoBackButton';
import { PROFILE_MAIN_LINK } from '../../../assets/utils/constants';
import { useEffect, useState } from 'react';
import mainAppApi from '../../../assets/api/MainAppApi';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import OrderCard from './OrderCard/OrderCard';
const LIMIT = 25

function Orders() {
    const navigate = useNavigate()

    const [data, setData] = useState(null)
    const [preloaders, setPreloaders] = useState({
        getData: true,
    })

    useEffect(() => {
        mainAppApi.getOrders({
            limit: LIMIT,
        })
            .then((res) => {
                console.log(res)
                setData(res)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    getData: false,
                }))
            })
    }, [])

    return (
        <div className='orders'>
            <div className='orders__heading'>
                <ProfileGoBackButton
                    onClick={() => {
                        navigate(`/${PROFILE_MAIN_LINK}`)
                    }}
                />
                <div className='orders__heading-title-box' >
                    <p className='orders__heading-title'>Orders</p>
                </div>
            </div>
            {preloaders.getData ?
                <div className='orders__preloader'>
                    <MiniPreloader />
                </div>
                :
                data && data.data.length > 0 ?
                    <div className='orders__list'>
                        {data.data.map((order, i) => (
                            <OrderCard order={order} key={`orders__list-item${order._id}`}>

                            </OrderCard>
                        ))}
                    </div>
                    :
                    <p className='orders__no-item'>No Orders Yet</p>
            }

        </div>
    );
}

export default Orders